import React from 'react'

function IconLink(props) {
  const { link, title, icon, color } = props
  return (
    <a href={link} target={'_blank'} rel="noopener noreferrer" style={{ fontSize: "15px", textDecoration:'underline', color: color }}>
      {title} <i style={{ color: color}} className={icon} />
    </a>
  )
}

export default IconLink
